module.exports = __webpack_public_path__ + "img/dfxj.0f164f3d.png";